import axios from 'axios';

const API_URL = process.env.REACT_APP_SERVER_URL + "/notifications";

export interface Notification {
    id: number;
    type: string;
    title: string;
    message: string | null;
    link_url: string | null;
    entity_type: string | null;
    entity_id: number | null;
    warehouse_id: number | null;
    target_role: string | null;
    created_time: string;
    read_at: string | null;
}

export interface NotificationListResponse {
    data: Notification[];
    total: number;
    page: number;
    limit: number;
    totalPages: number;
}

export interface NotificationQueryOptions {
    type?: string;
    unreadOnly?: boolean;
    page?: number;
    limit?: number;
}

const NotificationService = {
    getNotifications: async (
        userId: number,
        warehouseId: string | null,
        role: string | null,
        options: NotificationQueryOptions = {}
    ): Promise<NotificationListResponse> => {
        const token = localStorage.getItem('gpcwstoken_kw');
        const params: Record<string, string | number> = { user_id: userId };
        if (warehouseId != null) params.warehouse_id = warehouseId;
        if (role != null) params.role = role;
        if (options.type) params.type = options.type;
        if (options.unreadOnly) params.unread_only = 'true';
        if (options.page != null) params.page = options.page;
        if (options.limit != null) params.limit = options.limit;
        const response = await axios.get(`${API_URL}/`, {
            params,
            headers: { Authorization: `Bearer ${token}` },
        });
        return response.data;
    },

    getById: async (userId: number, warehouseId: string | null, role: string | null, id: number): Promise<Notification | null> => {
        const token = localStorage.getItem('gpcwstoken_kw');
        const params: Record<string, string | number> = { user_id: userId };
        if (warehouseId != null) params.warehouse_id = warehouseId;
        if (role != null) params.role = role;
        const response = await axios.get(`${API_URL}/${id}`, {
            params,
            headers: { Authorization: `Bearer ${token}` },
        });
        return response.data;
    },

    getUnreadCount: async (userId: number, warehouseId: string | null, role: string | null): Promise<number> => {
        const token = localStorage.getItem('gpcwstoken_kw');
        const params: Record<string, string | number> = { user_id: userId };
        if (warehouseId != null) params.warehouse_id = warehouseId;
        if (role != null) params.role = role;
        const response = await axios.get(`${API_URL}/unreadCount`, {
            params,
            headers: { Authorization: `Bearer ${token}` },
        });
        return response.data.count ?? 0;
    },

    markRead: async (userId: number, notificationId: number): Promise<void> => {
        const token = localStorage.getItem('gpcwstoken_kw');
        await axios.post(`${API_URL}/${notificationId}/read`, { user_id: userId }, {
            headers: { Authorization: `Bearer ${token}` },
        });
    },

    markAllRead: async (userId: number, warehouseId: string | null, role: string | null): Promise<void> => {
        const token = localStorage.getItem('gpcwstoken_kw');
        await axios.post(`${API_URL}/markAllRead`, { user_id: userId, warehouse_id: warehouseId, role }, {
            headers: { Authorization: `Bearer ${token}` },
        });
    },

    clearAll: async (userId: number, warehouseId: string | null, role: string | null): Promise<void> => {
        const token = localStorage.getItem('gpcwstoken_kw');
        await axios.post(`${API_URL}/clearAll`, { user_id: userId, warehouse_id: warehouseId, role }, {
            headers: { Authorization: `Bearer ${token}` },
        });
    },
};

export default NotificationService;
